//hooks
import React, {useState, useEffect} from 'react';

//component
import Booking from '../popup/Booking';

//material ui
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';

//material ui icons
import LanguageIcon from '@mui/icons-material/Language';

//image
import chamHotelLogo from "../assets/images/header_image/logo_white.png"

//react-router
import { Link } from 'react-router-dom';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

const pages = ['home', 'about', 'rooms', 'amenities', 'gallery', 'contact'];

function Header() {
  // start the translation way
  const { t } = useTranslation();

  // change the lang on click
  const handleClick = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
    window.location.reload()
  };
  // end the translation way

  // set default language only once
  useEffect(() => {
  const savedLang = localStorage.getItem("i18nextLng");
  const alreadyReloaded = localStorage.getItem("reloaded");
  const lang = savedLang && savedLang.startsWith("en") ? "ar" : savedLang ?? "en";    
  if(!alreadyReloaded) {
    localStorage.setItem("reloaded", "true");
    window.location.reload();
    i18n.changeLanguage(lang);
  }
  }, []);

  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };


  return (
    <AppBar className={`py-2 !bg-primaryColor`}   
    sx={{
    // backgroundColor: 'rgba(255, 255, 255, 0.2)', // transparent white
    // backdropFilter: 'blur(11px)', // blur effect
    // WebkitBackdropFilter: 'blur(11px)', // Safari support
    direction: i18n.language === "en" ? "ltr" : "rtl",
    }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
            {/* more thatn 900px */}
            <Typography sx={{display: { xs: 'none', md: 'flex' },}}>
                <img className='w-[70px]' src={chamHotelLogo} alt='no_logo'/>
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex'}, justifyContent: "center", gap: "13px"}}>
            {pages.map((page, index) => (
                <Link key={index} to={`${page === "home" ? "/" : `/${page}`}`}>
                    <Button
                    key={page}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, display: 'block'}}
                    className={`${i18n.language === "en" ? "!font-palab" : "!font-helvetica-arabic-light"} !text-white`}
                    >
                    {t(page)}
                    </Button>
                </Link>
            ))}
            </Box>

            {/* less than 900px */}
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                className='!text-white'
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: 'block', md: 'none' } }}
                >
                {pages.map((page, index) => (
                    <MenuItem key={index} onClick={handleCloseNavMenu}>
                      <Link to={`${page === "home" ? "/" : `/${page}`}`}>
                        <Typography className={`${i18n.language === "en" ? "!font-palab" : "!font-helvetica-arabic-light"} !text-primaryColor`} sx={{ textAlign: 'center' }}>{t(page)}</Typography>
                      </Link>
                    </MenuItem>
                ))}
                </Menu>
            </Box>
            <Typography
                variant="h5"
                noWrap
                component="a"
                href="#app-bar-with-responsive-menu"
                sx={{
                ml: 2,
                display: { xs: 'flex;', md: 'none' },
                flexGrow: 1,
                }}
            >
                <img className='w-[70px]' src={chamHotelLogo} alt='no_logo'/>
            </Typography>
          
            
            <Box sx={{display: 'flex', flexDirection: {xs: "column", sm: "row"}}}>
              {/* <Button
              sx={{
                width: {sm: "119px", xs: "90px"},
                height: {sm: "37px", xs: "30px"},
                fontSize: {sm: "14px", xs: "11px"}
              }}
              className={`!bg-secondaryColor !text-primaryColor ${i18n.language === "en" ? "!font-palab" : "!font-helvetica-arabic-light"} `}
              onClick={()=>setOpen(true)}
              >
                {t("book_now")}
              </Button> */}
              <Button
                onClick={handleClick}
                className='!text-white'
                style={{fontWeight: "bold"}}
              >
                <LanguageIcon fontSize="small" />
                <span>{i18n.language === "ar" ? t("En") : t("Ar")}</span>
              </Button>
            </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Header;
